<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="units-list">
    <div class="container">
        <div class="row toolbar-row mb-2">
            <ng-container *ngFor="let terminalButton of terminalMarkersArray">
                <button
                        (click)="modeChanged(modeType.TERMINAL, terminalButton.index)"
                        *ngIf="terminalButton.index === 0 || historyService.logicalTopology.layersModeEnabled"
                        [disabled]="!historyService.isEditModeEnabled"
                        class="units-list__item unit unit--ts btn btn-no-style"
                >
                    <winde-ctx-sensitive-help
                            container="div.step--1"
                            placement="right"
                            tooltipTextPath="projectView.enterLocations.icon.node.layer_{{ terminalButton.index }}"
                    >
                        <span
                                class="unit__icon {{
                                historyService.toolbarMode === modeType.TERMINAL &&
                                historyService.currentMarkerIndex === terminalButton.index
                                    ? terminalButton.iconName + '-active'
                                    : terminalButton.iconName
                            }}"
                        ></span>
                    </winde-ctx-sensitive-help>
                </button>
            </ng-container>
        </div>
        <div class="form-check row item_row">
            <label class="form-check-label">
                <input
                        (change)="historyService.polygonsService.toggleStoredPolygons()"
                        [(ngModel)]="historyService.polygonsService.isShowStoredPolygons"
                        class="form-check-input show-polygon-toggle"
                        type="checkbox"
                />
                Show polygons
            </label>
        </div>
        <div class="row toolbar-row item_row">
            <button
                    (click)="startHouseDetection($event)"
                    [disabled]="
                    !historyService.isEditModeEnabled ||
                    (historyService.logicalTopology.layersModeEnabled && historyService.logicalTopology.activeLayerIdx < 0)
                "
                    class="btn btn-link btn-sm btn-house-detection"
            >
                {{ 'project.houseDetection.title' | translate }}
            </button>
            <button
                    [disabled]="!historyService.isEditModeEnabled"
                    [routerLink]="['/', { outlets: { popup: 'project-view/house-detection' } }]"
                    class="btn-house-detection-conf btn btn-no-style"
            >
                <winde-ctx-sensitive-help container="div.step--1" tooltipTextPath="projectView.enterLocations.btn.houseDetection">
                    <button windeActionIcon>
                        <sui-svg-icon icon="cog" windeGrey/>
                    </button>
                </winde-ctx-sensitive-help>
            </button>
        </div>
        <div class="row toolbar-row item_row">
            <button (click)="openImportModal($event)" [disabled]="!historyService.isEditModeEnabled" class="btn btn-link btn-sm btn-import">
                Import topology
            </button>
            <button
                    (click)="downloadTemplate()"
                    [disabled]="!historyService.isEditModeEnabled"
                    class="btn-import-template btn btn-no-style"
            >
                <winde-ctx-sensitive-help container="div.step--1" tooltipTextPath="projectView.enterLocations.btn.downloadTemplate">
                    <button windeActionIcon>
                        <sui-svg-icon icon="table" windeGrey/>
                    </button>
                </winde-ctx-sensitive-help>
            </button>
        </div>
    </div>
</div>
